import { render, staticRenderFns } from "./pdfDownloadPage.vue?vue&type=template&id=bfb40f08&scoped=true"
import script from "./pdfDownloadPage.vue?vue&type=script&lang=js"
export * from "./pdfDownloadPage.vue?vue&type=script&lang=js"
import style0 from "./pdfDownloadPage.vue?vue&type=style&index=0&id=bfb40f08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb40f08",
  null
  
)

export default component.exports